<template>
  <div class="app-wrapper" :class="classObj">
    <sidebar class="sidebar-container"></sidebar>
    <div class="hasTagsView main-container">
      <div class="layout-header" ref="headerMain">
        <div class="layout-header-left" :style="{width: `${leftMaxWidth}px`}">
          <navbar />
          <tags-view />
        </div>
        <HeaderRight ref="rightMain"></HeaderRight>
      </div>
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain, TagsView } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import HeaderRight from './components/HeaderRight'
import { mapState } from 'vuex'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    TagsView,
    HeaderRight
  },
  mixins: [ResizeMixin],
  data() {
    return {
      leftMaxWidth: 500 // 设一个默认值
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.leftMaxWidth = this.$refs.headerMain.clientWidth - this.$refs.rightMain.rightWidth
    })
  },
  computed: {
    ...mapState({
      needTagsView: state => state.settings.tagsView
    }),
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
  }
  .layout-header {
    display: flex;
    &-left {
      flex: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue